/**
 * A/B 测试 / 多版本菜单的 per-order seed（请求头 `X-Order-Seed`）。
 *
 * 一单一个：进店生成，下单成功（`clearProductList`）清掉，下一单再生成。后端按它给实验分组
 * （`ABTestService::resolveVariant` 空 seed 直接不分组）、给推荐留出对照组，下单时用它认「是不是同一位顾客在重试」。
 * 所以读菜单用的 seed 必须就是这一单下单用的 seed（多版本菜单 B6，research README §1.2）。
 *
 * seed 绑在**门店 UUID** 上：同一家店从 url_id 链接（`/v/my-cafe/...`）和 UUID 链接进来是同一家，seed 不变；
 * 换一家店才换新的。UUID 要等 get-venue 回来才知道，所以真正的绑定在 get-venue 的响应里做（`store/venueEntry.js`）。
 */

/** RFC4122 v4（后端只认 v4 形状，`ApiCommonController.php:143-149`） */
export function newOrderSeed() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // RFC4122 v4 fallback for older browsers
  // 老浏览器使用的 RFC4122 v4 兜底实现
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

const sameUrlId = (a, b) => typeof a === 'string' && typeof b === 'string' && a.toLowerCase() === b.toLowerCase()

/**
 * store 里的 seed 是不是已经属于路由上这家店。`venueKey` 可以是 UUID，也可以是 url_id：
 * url_id 只在 seed 绑的正是当前这家店（`currentVenueId === venueId`）、且等于这家店存下的 url_id 时才认，
 * 不能拿 A 店的 url_id 认 B 店的 seed。
 */
export function seedBelongsToVenue(state, venueKey) {
  if (!state || !state.orderSeed || !state.currentVenueId || !venueKey) return false
  if (state.currentVenueId === venueKey) return true
  const urlId = state.venueHome && state.venueHome.urlId
  return !!urlId && state.currentVenueId === state.venueId && sameUrlId(venueKey, urlId)
}

/**
 * get-venue 回来、知道 UUID 之后，seed 该怎么办：
 * - `keep`：已经绑在这家店的 UUID 上；
 * - `rebind`：是进店前按 url_id 先生成的那一份（同一家店）⇒ 值不变，改绑到 UUID；
 * - `new`：没有 seed（第一次进店 / 换店被 resetState 清了 / 上一单已下完），或绑的是别家店。
 */
export function seedBindingFor(state, { venueId, urlId } = {}) {
  if (state && state.orderSeed && state.currentVenueId) {
    if (state.currentVenueId === venueId) return 'keep'
    if (urlId && sameUrlId(state.currentVenueId, urlId)) return 'rebind'
  }
  return 'new'
}
